import statuses from '../status/index';

export default (statusArr, id) => {
    if (id === '') {
        return statuses.STANDBY;
    }
    const index = statusArr.findIndex(s => s.id === id);
    return (index > -1) ? statusArr[index].status : statuses.STANDBY;
};
